const SERVICE_IDENTIFIER = {
    COMPONENTS: Symbol.for('COMPONENTS'),
    APPLICATION: Symbol.for('APPLICATION'),
    COMPONENT: Symbol.for('Component'),
    SERVICE: Symbol.for('SERVICE'),
    ENTITY: Symbol.for('ENTITY'),
    TRANSITION: Symbol.for('TRANSITION'),
};

export default SERVICE_IDENTIFIER;